module.exports = __webpack_public_path__ + "img/MarcusWinter_140x140_rund.2454ce32.jpg";